import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const LegalPageTemplate = ({ title, subtitle, children }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      '.legal-content',
      { y: 30, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 80%',
        },
      }
    );
  }, []);

  return (
    <div ref={sectionRef} className="min-h-screen bg-white pt-32 pb-20">
      {/* Hero Section */}
      <section className="container mx-auto px-4 lg:px-8 mb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <div className="inline-flex items-center gap-2 bg-secondary/20 text-primary font-semibold px-4 py-2 rounded-full mb-6">
            <span>Legal Information</span>
          </div>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-dark mb-6">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg md:text-xl text-gray-600">
              {subtitle}
            </p>
          )}
        </motion.div>
      </section>

      {/* Content Section */}
      <section className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="legal-content max-w-4xl mx-auto"
        >
          <div className="glass-card p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              {children}
            </div>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default LegalPageTemplate;
